// extracted by mini-css-extract-plugin
export const divider = "Divider-module--divider--2q3Wp";
export const vertical = "Divider-module--vertical--3kQjb";